module.exports = __webpack_public_path__ + "media/images/banner-cs-aca579bebc67ac46ceae7edb57dc8964.png";